<template>
  <div id="form2">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        <b>a)</b>  Ein Professor hält in einem Vorlesungssaal eine Vorlesung, dabei ist das Gemurmel der Studenten eine Störung der Intensität I = 10-6 . Es soll ein Störabstand von 15+ dB erreicht werden. Welchen Schallpegel muss der Professor haben um diesen Störabstand zu erreichen?
    </p>
    <p style="text-align: left;">
        <input v-model="message22" placeholder="Feld1" /> dB
    </p>
    <p style="text-align: left;">
        <b>b)</b>  Der Professor wird nun über zwei Lautsprecher mit derselben Intensität übertragen. Welchen Schallpegel erreicht das Nutzsignal?
    </p>
    <p style="text-align: left;">
        <input v-model="message23" placeholder="Feld2" /> dB
    </p>

    <button id="button3" v-on:click="check2">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message22: '',
        message23: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check2() {
        if ( (this.message22 && this.message22 == "75" || this.message22 == "75,0") &&
            (this.message23 && this.message23 == "78" || this.message23 == "78,0") 
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "audioForm10_done", state: true})
                localStorage.setItem("audioForm10_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */
#button3 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form2 {
    height: 1000px;;
}
</style>